// 特典センター（右下FAB＋モーダル）の制御。
// カート内の「缶換算数」を基準に、各施策ブロック（追加購入・プレゼント）の解錠と
// FABの赤丸バッジ・アニメーションを更新する。設定は window.PerkConfig 経由。
(() => {
  const fab = document.querySelector("[data-perk-fab]");
  const overlay = document.querySelector("[data-perk-overlay]");
  if (!fab || !overlay) return;

  const config = window.PerkConfig || {};
  const boxEquivalents = config.boxEquivalents || {};

  const countEl = fab.querySelector("[data-perk-count]");
  const addonBlocks = overlay.querySelectorAll("[data-perk-addon-block]");
  const giftBlocks = overlay.querySelectorAll("[data-perk-gift-block]");
  const fsbBlock = overlay.querySelector("[data-perk-fsb-block]");
  const fsbThreshold = fsbBlock ? parseInt(fsbBlock.getAttribute("data-threshold"), 10) || 0 : 0;
  const fsbTemplate = fsbBlock ? fsbBlock.getAttribute("data-remaining-template") || "あと[金額]" : "";

  const selectedAddons = {}; // { variantId: qty }
  let canEquivTotal = 0;

  // 直近のカート状態。LPの数量入力など「まだカートに入っていない選択」を
  // 送料無料の進捗へ上乗せして描き直すために保持する。
  let lastItems = [];
  let cartTotalCents = 0;
  let pendingTotalCents = 0;

  // 画面下端に追従するバー（商品ページの「カートに追加」、LPの追従CTA）が出ている間は、
  // FABがバーと重ならないよう一段持ち上げる（表示中のバーのうち最も高いものに合わせる）。
  // LPの追従CTAはボタンの上にも余白を持つため、余白を除いたボタンの上端を基準にする。
  // LPの追従CTAは「画面上」に置いた場合は重ならないので対象外。
  const stickyBars = document.querySelectorAll(
    '.sticky-add-to-cart, [data-lp-sicta-bar][data-position="bottom"]'
  );
  if (stickyBars.length > 0) {
    const syncFabOffset = () => {
      let barHeight = 0;
      stickyBars.forEach((bar) => {
        if (!bar.classList.contains("is-visible")) return;
        const content = bar.querySelector(".lp-sicta-bar__inner");
        const height = content ? bar.offsetHeight - content.offsetTop : bar.offsetHeight;
        barHeight = Math.max(barHeight, height);
      });
      fab.style.bottom = barHeight > 0 ? barHeight + 8 + "px" : "";
    };
    const observer = new MutationObserver(syncFabOffset);
    stickyBars.forEach((bar) => {
      observer.observe(bar, { attributes: true, attributeFilter: ["class"] });
    });
    window.addEventListener("resize", syncFabOffset);
    syncFabOffset();
  }

  function getRootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  }

  // カート行1つぶんの缶換算数（単価）を返す
  function equivalentOf(item) {
    const itemType = item.properties ? item.properties["_item_type"] : null;
    if (itemType === "can") return 1;
    return boxEquivalents[String(item.product_id)] || 0;
  }

  function giftDesiredQty(threshold, mode) {
    if (canEquivTotal < threshold) return 0;
    return mode === "multiply" ? Math.floor(canEquivTotal / threshold) : 1;
  }

  // クエストカード（進捗バー・カウント・達成状態の色）を更新し、
  // アンロック済みかどうかを返す
  function updateQuestUI(block, threshold) {
    const unlocked = canEquivTotal >= threshold;
    const quest = block.querySelector(".perk-quest");
    if (!quest) return unlocked;

    quest.classList.toggle("perk-quest--unlocked", unlocked);

    const fill = quest.querySelector("[data-perk-quest-fill]");
    if (fill) {
      fill.style.width = Math.min(100, Math.round((canEquivTotal / threshold) * 100)) + "%";
    }
    const questCount = quest.querySelector("[data-perk-quest-count]");
    if (questCount) {
      questCount.textContent = Math.min(canEquivTotal, threshold) + " / " + threshold;
    }
    return unlocked;
  }

  // 送料無料カード（金額ベース）の進捗バー・達成状態を更新し、達成済みかどうかを返す
  function updateFreeShippingUI(totalPriceCents) {
    if (!fsbBlock || fsbThreshold <= 0) return false;
    const quest = fsbBlock.querySelector("[data-perk-fsb-quest]");
    const achieved = totalPriceCents >= fsbThreshold;
    if (quest) quest.classList.toggle("perk-quest--unlocked", achieved);

    const fill = fsbBlock.querySelector("[data-perk-fsb-fill]");
    if (fill) {
      fill.style.width = Math.min(100, Math.round((totalPriceCents / fsbThreshold) * 100)) + "%";
    }
    const countEl = fsbBlock.querySelector("[data-perk-fsb-count]");
    if (countEl) {
      const remainingYen = Math.max(0, Math.ceil((fsbThreshold - totalPriceCents) / 100));
      countEl.textContent = achieved ? "" : fsbTemplate.replace("[金額]", "¥" + remainingYen.toLocaleString());
    }
    return achieved;
  }

  function updateFromItems(items, totalPrice) {
    lastItems = items || [];
    cartTotalCents = totalPrice || 0;
    canEquivTotal = lastItems.reduce((sum, item) => sum + equivalentOf(item) * item.quantity, 0);

    let activatedCount = 0;

    addonBlocks.forEach((block) => {
      const threshold = parseInt(block.getAttribute("data-threshold"), 10) || 1;
      const unlocked = updateQuestUI(block, threshold);

      block.classList.toggle("perk-block--locked", !unlocked);
      block.querySelectorAll("[data-perk-minus], [data-perk-plus]").forEach((btn) => {
        const row = btn.closest("[data-perk-badge-row]");
        const soldout = row && row.classList.contains("perk-badge-row--soldout");
        btn.disabled = !unlocked || soldout;
      });
      if (!unlocked) resetAddonSelection(block);
      updateAddonAddButton(block);
      if (unlocked) activatedCount++;
    });

    giftBlocks.forEach((block) => {
      const threshold = parseInt(block.getAttribute("data-threshold"), 10) || 6;
      const mode = block.getAttribute("data-mode") === "multiply" ? "multiply" : "single";
      const unlocked = updateQuestUI(block, threshold);
      const desired = giftDesiredQty(threshold, mode);

      block.classList.toggle("perk-gift--locked", !unlocked);
      const qtyEl = block.querySelector("[data-perk-gift-qty]");
      if (qtyEl) qtyEl.textContent = desired;
      if (unlocked) activatedCount++;
    });

    if (updateFreeShippingUI(cartTotalCents + pendingTotalCents)) activatedCount++;

    if (countEl) {
      countEl.hidden = activatedCount < 1;
      countEl.textContent = activatedCount;
    }
    fab.classList.toggle("gift-fab--idle", activatedCount < 1);
  }

  // LP側の数量入力が発火する。カート未投入の金額を進捗に映すためのもので、
  // 缶換算数（canEquivTotal）には影響させない＝解錠条件は実際のカートのまま。
  document.addEventListener("perk:pending-total", (event) => {
    const cents = Number(event.detail && event.detail.cents) || 0;
    if (cents === pendingTotalCents) return;
    pendingTotalCents = cents;
    updateFromItems(lastItems, cartTotalCents);
  });

  function refresh() {
    fetch(getRootUrl() + "cart.js", { cache: "no-store" })
      .then((res) => res.json())
      .then((cart) => updateFromItems(cart.items, cart.total_price))
      .catch(() => {});
  }

  // 条件達成済みの施策はモーダルを開いた時点でアコーディオンを展開しておく
  function expandUnlockedBlocks() {
    overlay
      .querySelectorAll(
        "[data-perk-addon-block]:not(.perk-block--locked), [data-perk-gift-block]:not(.perk-gift--locked)"
      )
      .forEach((block) => {
        block.classList.add("perk-open");
        const toggle = block.querySelector("[data-perk-acc-toggle]");
        if (toggle) toggle.setAttribute("aria-expanded", "true");
      });
  }

  // --- モーダル開閉 ---
  const open = () => {
    overlay.hidden = false;
    expandUnlockedBlocks();
    // 一度開いたら注意喚起アニメーション（揺れ・点滅）を止める
    fab.classList.add("gift-fab--seen");
  };
  const close = () => {
    overlay.hidden = true;
    // 直接購入の案内は「ガード経由で開いた時だけ」の表示。閉じたらリセットし、
    // 通常のFABタップで開いた際に残らないようにする
    resetBuyNowNotice();
    // ×ボタンや背景タップで閉じた場合は「やめておく」を選んだものとして扱う
    resolveConfirm(false);
  };
  fab.addEventListener("click", open);
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay || e.target.closest("[data-perk-close]")) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeZoom();
      close();
    }
  });

  // --- 施策のアコーディオン開閉（クエストカードをタップで中身を下に展開） ---
  function toggleAccordion(toggle) {
    const blockEl = toggle.closest("[data-perk-addon-block], [data-perk-gift-block]");
    if (!blockEl) return;
    const open = blockEl.classList.toggle("perk-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      // 展開した中身が固定高さのシート内に収まるよう、下方向へスクロールして見せる
      setTimeout(() => {
        blockEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }, 50);
    }
  }
  overlay.addEventListener("click", (e) => {
    const toggle = e.target.closest("[data-perk-acc-toggle]");
    if (toggle) toggleAccordion(toggle);
  });
  overlay.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const toggle = e.target.closest("[data-perk-acc-toggle]");
    if (toggle) {
      e.preventDefault();
      toggleAccordion(toggle);
    }
  });

  // --- 画像の拡大表示（ライトボックス） ---
  const zoomOverlay = document.querySelector("[data-perk-zoom-overlay]");
  const zoomImage = document.querySelector("[data-perk-zoom-image]");
  function closeZoom() {
    if (zoomOverlay) zoomOverlay.hidden = true;
  }
  overlay.addEventListener("click", (e) => {
    const zoomBtn = e.target.closest("[data-perk-zoom]");
    if (!zoomBtn || !zoomOverlay || !zoomImage) return;
    zoomImage.src = zoomBtn.getAttribute("data-perk-zoom");
    zoomOverlay.hidden = false;
  });
  if (zoomOverlay) {
    zoomOverlay.addEventListener("click", closeZoom);
  }

  // --- 追加購入のステッパーとカート追加（施策ブロックごと） ---
  function blockSelectedTotal(block) {
    let total = 0;
    block.querySelectorAll("[data-perk-badge-row]").forEach((row) => {
      total += selectedAddons[row.getAttribute("data-variant-id")] || 0;
    });
    return total;
  }

  function resetAddonSelection(block) {
    block.querySelectorAll("[data-perk-badge-row]").forEach((row) => {
      delete selectedAddons[row.getAttribute("data-variant-id")];
      const qtyEl = row.querySelector("[data-perk-qty]");
      if (qtyEl) qtyEl.textContent = "0";
    });
  }

  function updateAddonAddButton(block) {
    const addBtn = block.querySelector("[data-perk-badge-add]");
    if (!addBtn) return;
    const threshold = parseInt(block.getAttribute("data-threshold"), 10) || 1;
    addBtn.disabled = blockSelectedTotal(block) < 1 || canEquivTotal < threshold;
  }

  overlay.addEventListener("click", (e) => {
    const minus = e.target.closest("[data-perk-minus]");
    const plus = e.target.closest("[data-perk-plus]");
    if (!minus && !plus) return;
    const row = e.target.closest("[data-perk-badge-row]");
    const block = e.target.closest("[data-perk-addon-block]");
    if (!row || !block) return;
    const variantId = row.getAttribute("data-variant-id");
    const qtyEl = row.querySelector("[data-perk-qty]");
    const current = selectedAddons[variantId] || 0;
    const next = plus ? current + 1 : Math.max(0, current - 1);
    selectedAddons[variantId] = next;
    if (qtyEl) qtyEl.textContent = next;
    updateAddonAddButton(block);
  });

  overlay.addEventListener("click", (e) => {
    const addBtn = e.target.closest("[data-perk-badge-add]");
    if (!addBtn || addBtn.disabled) return;
    const block = addBtn.closest("[data-perk-addon-block]");
    if (!block) return;

    const items = [];
    block.querySelectorAll("[data-perk-badge-row]").forEach((row) => {
      const variantId = row.getAttribute("data-variant-id");
      const qty = selectedAddons[variantId] || 0;
      if (qty > 0) {
        items.push({ id: variantId, quantity: qty, properties: { _item_type: "badge" } });
      }
    });
    if (items.length === 0) return;

    addBtn.disabled = true;
    const originalText = addBtn.textContent;
    addBtn.textContent = "追加中...";

    fetch((config.cartAddUrl || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => ({}))
            .then((err) => {
              throw new Error(err.description || "カートへの追加に失敗しました。");
            });
        }
        // カートページでは行の再描画が必要なためリロードする
        if (document.querySelector("cart-items")) {
          window.location.reload();
          return;
        }
        resetAddonSelection(block);
        addBtn.textContent = "追加しました！";
        setTimeout(() => {
          addBtn.textContent = originalText;
          updateAddonAddButton(block);
        }, 1500);
        refresh();
      })
      .catch((err) => {
        alert(err.message || "カートへの追加に失敗しました。時間をおいて再試行してください。");
        addBtn.textContent = originalText;
        updateAddonAddButton(block);
      });
  });

  // --- 状態更新のトリガー ---
  document.addEventListener("DOMContentLoaded", () => {
    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData && event.cartData.items) {
          updateFromItems(event.cartData.items, event.cartData.total_price);
        }
      });
    }
    refresh();
  });

  // openWithNotice: 直接購入ガード（buy-now-guard）から呼ばれ、
  // モーダル上部の案内文（直接購入では特典が付かない旨）と
  // 「そのまま決済へ進む」「今後この案内を表示しない」を表示した状態で開く
  const buyNowNote = overlay.querySelector("[data-perk-buy-now-note]");
  const buyNowProceed = overlay.querySelector("[data-perk-buy-now-proceed]");
  const buyNowOptout = overlay.querySelector("[data-perk-buy-now-optout]");
  let buyNowProceedHandler = null;

  function resetBuyNowNotice() {
    if (buyNowNote) buyNowNote.hidden = true;
    if (buyNowProceed) buyNowProceed.hidden = true;
    if (buyNowOptout) buyNowOptout.hidden = true;
    buyNowProceedHandler = null;
  }

  if (buyNowProceed) {
    buyNowProceed.addEventListener("click", () => {
      if (buyNowProceedHandler) buyNowProceedHandler();
    });
  }
  if (buyNowOptout) {
    buyNowOptout.addEventListener("click", () => {
      // ブラウザに記憶し、以降は直接購入時の割り込み自体を行わない（buy-now-guardが参照）
      try {
        localStorage.setItem("perk-buy-now-optout", "1");
      } catch (e) {
        // localStorageが使えない環境ではこのページ内でのみ非表示
      }
      resetBuyNowNotice();
    });
  }

  // confirmRemoval: カートで特典が失われる操作（数量減・削除）をした際に、
  // ブラウザ標準の confirm() の代わりにモーダル内で「削除する／やめておく」を
  // 選んでもらう。cart-gift-sync.js から呼ばれ、選択結果をPromiseで返す。
  const confirmBlock = overlay.querySelector("[data-perk-confirm]");
  const confirmMessage = overlay.querySelector("[data-perk-confirm-message]");
  const confirmYes = overlay.querySelector("[data-perk-confirm-yes]");
  const confirmNo = overlay.querySelector("[data-perk-confirm-no]");
  let confirmResolve = null;

  function resolveConfirm(result) {
    if (confirmBlock) confirmBlock.hidden = true;
    if (confirmResolve) {
      const resolve = confirmResolve;
      confirmResolve = null;
      resolve(result);
    }
  }
  if (confirmYes) {
    confirmYes.addEventListener("click", () => {
      resolveConfirm(true);
      close();
    });
  }
  if (confirmNo) {
    confirmNo.addEventListener("click", () => {
      resolveConfirm(false);
      close();
    });
  }

  window.PerkFab = {
    refresh,
    open,
    openWithNotice(onProceed) {
      if (buyNowNote) buyNowNote.hidden = false;
      buyNowProceedHandler = typeof onProceed === "function" ? onProceed : null;
      if (buyNowProceed) buyNowProceed.hidden = buyNowProceedHandler === null;
      if (buyNowOptout) buyNowOptout.hidden = false;
      open();
    },
    confirmRemoval(message) {
      if (!confirmBlock || !confirmMessage) return Promise.resolve(true);
      confirmMessage.textContent = message;
      confirmBlock.hidden = false;
      open();
      return new Promise((resolve) => {
        // モーダルを閉じるボタン／背景タップでキャンセル扱いにする
        confirmResolve = resolve;
      });
    },
  };
})();
